import React, {useState} from 'react'

import {normalize} from '@utils/normalize.js'

/** Escapes the special characters of a regular expression, to match text literally */
export function escapeRegex(text: string) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

/** The text with the parts matching the query (case and accent insensitive) in bold, for suggestion and option lists */
export function boldMatch(text: string, query: string) {
    const parts = text.split(new RegExp(`(${escapeRegex(query)})`, 'gi'))

    return parts.map((part, i) => (
        <span key={i} style={normalize(part?.toLowerCase()) === normalize(query?.toLowerCase()) ? {fontWeight: 'bold'} : {}}>
            {part}
        </span>
    ))
}

let fieldIdCounter = 0

/**
 * A stable id for a field's control, so its label can point at it (htmlFor/aria-labelledby). The caller's id is used
 * as is when given (code looks fields up by it), otherwise one is generated once per instance, e.g. 'field-17'.
 */
export function useFieldId(id?: string) {
    const [generatedId] = useState(() => `field-${++fieldIdCounter}`)

    return id || generatedId
}
